// Przestrzeń nazw 'layout': teksty ramy aplikacji (layouty, chip użytkownika, okruszki).
// Menu boczne i nagłówek strony mają własną przestrzeń `navigation`.
//
// VERIFY: cały plik, brak w mockupie (mockup nie ma szuflady menu na wąskim ekranie, linku do
// profilu ani okruszków).
export default {
  menu: {
    // Tytuł szuflady z menu na wąskim ekranie.
    title: 'Menu',
  },
  userChip: {
    // Chip w stopce menu jest jedynym wejściem do ekranu Profil, gdzie zmienia się hasło.
    profileLink: 'Profil i hasło',
  },
  // Układ dla roli call_taker: pasek wyszukiwania numeru nad osadzoną wtyczką Copilot.
  callTaker: {
    searchPlaceholder: 'numer telefonu',
    // Tag <phone> podmienia <Trans> na wyróżniony numer.
    currentlyViewing: 'Aktualnie wyświetlany numer: <phone>{{phoneNumber}}</phone>',
    frameTitle: 'Wtyczka Copilot',
  },
  // Okruszki zbudowane z segmentów URL (`useBreadcrumbs`). Klucz to segment ścieżki, więc
  // wpisy dla ukrytych sekcji zostają, dopóki ich trasy istnieją w kodzie. Korzeń okruszków
  // bierze etykietę z `navigation:sections.dashboard.label`.
  breadcrumbs: {
    aiPerformance: 'Skuteczność AI',
    agents: 'Agenci AI',
    new: 'Nowy',
    'work-orders': 'Zlecenia',
    'phone-numbers': 'Numery telefonów',
    profile: 'Profil',
    support: 'Wsparcie',
    surveys: 'Ankiety',
    voices: 'Głosy',
  },
} as const;
